// Where a page sits: Datasets / <dataset> / Tasks / <task> / <model>. Every step but the last opens its page; long
// names are cut in the middle (the whole name on hover).
import { esc } from '../core'

export interface Crumb { label: string; go?: () => void }

const MAX = 48

/** `s` cut to `n` characters by taking out its middle. */
export function middle(s: string, n = MAX): string {
  if (s.length <= n) return s
  const head = Math.ceil((n - 1) / 2)
  return s.slice(0, head).trimEnd() + '…' + s.slice(s.length - (n - 1 - head)).trimStart()
}

/** `above`: the list is the pages above the current one, every step a link, with a trailing separator. */
export function crumbs(list: Crumb[], above = false): string {
  return '<nav class="rp-crumbs" aria-label="Breadcrumb">' + list.map((c, i) => {
    const text = esc(middle(c.label))
    const title = c.label.length > MAX ? ' title="' + esc(c.label) + '"' : ''
    const last = !above && i === list.length - 1
    const item = c.go && !last
      ? '<a href="javascript:void(0)" class="rp-crumb" data-crumb="' + i + '"' + title + '>' + text + '</a>'
      : '<span class="rp-crumb' + (last ? ' rp-crumb-here' : '') + '"' + title + (last ? ' aria-current="page"' : '') + '>' + text + '</span>'
    return (i ? '<span class="rp-crumb-sep">/</span>' : '') + item
  }).join('') + (above && list.length ? '<span class="rp-crumb-sep">/</span>' : '') + '</nav>'
}

export function wireCrumbs(root: HTMLElement, list: Crumb[]): void {
  Array.prototype.forEach.call(root.querySelectorAll('.rp-crumbs [data-crumb]'), (a: HTMLElement) => {
    const go = list[Number(a.getAttribute('data-crumb'))]?.go
    if (go) a.onclick = go
  })
}
